import React from 'react';
import { useLocation } from 'react-router-dom';
import { Breadcrumbs } from './custom-components';

const routeBreadcrumbsMap = {
  // Consent Management -> Consent
  '/templates': [{ label: 'Consent Management' }, { label: 'Consent' }, { label: 'Consent Templates' }],
  '/createConsent': [{ label: 'Consent Management' }, { label: 'Consent' }, { label: 'Create Consent' }],
  '/consent': [{ label: 'Consent Management' }, { label: 'Consent' }, { label: 'Consent Configuration' }],
  '/consent-system': [{ label: 'Consent Management' }, { label: 'Consent' }, { label: 'Consent Systems' }],
  '/consent-system/add': [{ label: 'Consent Management', link: '/consent-system' }, { label: 'Consent', link: '/consent-system' }, { label: 'Add System' }],
  '/consent-datasets': [{ label: 'Consent Management' }, { label: 'Consent' }, { label: 'Consent Datasets' }],
  '/consent-datasets/create': [{ label: 'Consent Management', link: '/consent-datasets' }, { label: 'Consent', link: '/consent-datasets' }, { label: 'Create Dataset' }],
  
  // Consent Management -> Cookies
  '/cookie-category': [{ label: 'Consent Management' }, { label: 'Cookies' }, { label: 'Cookie Categories' }],
  '/cookieslogs': [{ label: 'Consent Management' }, { label: 'Cookies' }, { label: 'Cookie Logs' }],
  '/registercookies': [{ label: 'Consent Management' }, { label: 'Cookies' }, { label: 'Cookie Templates' }],
  
  // Consent Management -> Rights Management (DSAR)
  '/user-portal-configuration': [{ label: 'Consent Management' }, { label: 'Rights Management (DSAR)' }, { label: 'User Portal Configuration' }],
  '/user-dashboard': [{ label: 'Consent Management' }, { label: 'Rights Management (DSAR)' }, { label: 'User Portal Branding' }],
  '/notification-templates': [{ label: 'Consent Management' }, { label: 'Rights Management (DSAR)' }, { label: 'Notification Templates' }],
  '/notification': [{ label: 'Consent Management' }, { label: 'Rights Management (DSAR)' }, { label: 'Notification Configuration' }],
  
  // GOVERNANCE
  '/consentLogs': [{ label: 'Governance' }, { label: 'Governance' }, { label: 'Consent Logs' }],
  '/dataProtectionOfficer': [{ label: 'Governance' }, { label: 'Governance' }, { label: 'Data Protection Officer (DPO)' }],
  '/ropa': [{ label: 'Governance' }, { label: 'Governance' }, { label: 'Record of Processing Activities (ROPA)' }],
  '/addROPAEntry': [{ label: 'Governance', link: '/ropa' }, { label: 'Governance', link: '/ropa' }, { label: 'Record of Processing Activities (ROPA)', link: '/ropa' }, { label: 'Add ROPA Entry' }],
  '/request': [{ label: 'Governance' }, { label: 'Grievances' }, { label: 'Grievance Requests' }],
  '/grievanceFormTemplates': [{ label: 'Governance' }, { label: 'Grievances' }, { label: 'Grievance Templates' }],
  '/grievance': [{ label: 'Governance' }, { label: 'Grievances' }, { label: 'Grievance Configuration' }],
  '/breach-notifications': [{ label: 'Governance' }, { label: 'Breach Management' }, { label: 'Breach Notification' }],
  '/reportBreach': [{ label: 'Governance', link: '/breach-notifications' }, { label: 'Breach Management' }, { label: 'Breach Notification', link: '/breach-notifications' }, { label: 'Report Breach' }],
  '/reportBreachEntry': [{ label: 'Governance', link: '/breach-notifications' }, { label: 'Breach Management' }, { label: 'Breach Notification', link: '/breach-notifications' }, { label: 'Report Breach Entry' }],
  '/dpb-digital-office-sync': [{ label: 'Governance' }, { label: 'Breach Management' }, { label: 'DPB Digital Office Sync' }],
  
  // REPORTS
  '/audit-compliance': [{ label: 'Reports' }, { label: 'Audit and Compliance Reports' }],
  '/createAudit': [{ label: 'Reports', link: '/audit-compliance' }, { label: 'Audit and Compliance Reports', link: '/audit-compliance' }, { label: 'Create Audit' }],
  '/data-compliance-report': [{ label: 'Reports' }, { label: 'Consent Callbacks and Data Deletion Report' }],
  '/data-deletion-purge-dashboard': [{ label: 'Reports' }, { label: 'Data deletion and purge dashboard' }],
  '/scheduler-stats': [{ label: 'Reports' }, { label: 'Scheduler Statistics' }],
  
  // SETTINGS -> PLATFORM CONFIGURATION
  '/systemConfiguration': [{ label: 'Settings' }, { label: 'Platform Configuration' }, { label: 'System Configuration' }],
  '/retention-policies': [{ label: 'Settings' }, { label: 'Platform Configuration' }, { label: 'Data Retention' }],
  
  // SETTINGS -> ADMIN
  '/business': [{ label: 'Settings' }, { label: 'Admin' }, { label: 'Business Units' }],
  '/roles': [{ label: 'Settings' }, { label: 'Admin' }, { label: 'Roles & Permissions' }],
  '/addRole': [{ label: 'Settings', link: '/roles' }, { label: 'Admin' }, { label: 'Roles & Permissions', link: '/roles' }, { label: 'Add Role' }],
  '/users': [{ label: 'Settings' }, { label: 'Admin' }, { label: 'Users & Teams' }],
  '/addUser': [{ label: 'Settings', link: '/users' }, { label: 'Admin' }, { label: 'Users & Teams', link: '/users' }, { label: 'Add User' }],
  '/organization-map': [{ label: 'Settings' }, { label: 'Admin' }, { label: 'Business Hierarchy' }],

  // Dashboard
  '/dashboard': [{ label: 'Dashboard' }],
  '/maindashboard': [{ label: 'Main Dashboard' }],
};

const GlobalBreadcrumbs = () => {
  const location = useLocation();
  const path = location.pathname;
  
  // Find exact match
  let items = routeBreadcrumbsMap[path];

  if (path === '/master') {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get('tab');
    if (tab === 'DataProcessor') {
      items = [{ label: 'Settings' }, { label: 'Platform Configuration' }, { label: 'Data Processors' }];
    } else if (tab === 'ProcessingActivity') {
      items = [{ label: 'Settings' }, { label: 'Platform Configuration' }, { label: 'Processing Activities' }];
    } else if (tab === 'Purpose') {
      items = [{ label: 'Settings' }, { label: 'Platform Configuration' }, { label: 'Processing Purposes' }];
    } else {
      items = [{ label: 'Settings' }, { label: 'Platform Configuration' }, { label: 'Master Data (PII data types, items)' }];
    }
  }

  // If no exact match, try matching prefixes for dynamic routes
  if (!items) {
    if (path.startsWith('/consent-system/edit/')) {
      items = [{ label: 'Consent Management', link: '/consent-system' }, { label: 'Consent', link: '/consent-system' }, { label: 'Edit System' }];
    } else if (path.startsWith('/consent-datasets/edit/')) {
      items = [{ label: 'Consent Management', link: '/consent-datasets' }, { label: 'Consent', link: '/consent-datasets' }, { label: 'Edit Dataset' }];
    } else if (path.startsWith('/updateRole/')) {
      items = [{ label: 'Administration', link: '/roles' }, { label: 'Roles & Permissions', link: '/roles' }, { label: 'Update Role' }];
    } else if (path.startsWith('/updateUser/')) {
      items = [{ label: 'Administration', link: '/users' }, { label: 'User Management', link: '/users' }, { label: 'Update User' }];
    } else if (path.startsWith('/createGrievanceForm')) {
      items = [{ label: 'Compliance', link: '/grievanceFormTemplates' }, { label: 'Complaints & Requests', link: '/grievanceFormTemplates' }, { label: 'Create Form' }];
    } else if (path.startsWith('/editRequest/')) {
      items = [{ label: 'Compliance', link: '/request' }, { label: 'Requests', link: '/request' }, { label: 'Edit Request' }];
    } else if (path.startsWith('/consent-deletion-detail/')) {
      items = [{ label: 'Administration', link: '/data-deletion-purge-dashboard' }, { label: 'Data Purge & Deletion', link: '/data-deletion-purge-dashboard' }, { label: 'Detail' }];
    } else if (path.startsWith('/createEmailTemplate')) {
      items = [{ label: 'Consent Management', link: '/templates' }, { label: 'Consent Templates', link: '/templates' }, { label: 'Email Template' }];
    } else if (path.startsWith('/createSmsTemplate')) {
      items = [{ label: 'Consent Management', link: '/templates' }, { label: 'Consent Templates', link: '/templates' }, { label: 'SMS Template' }];
    }
  }

  // Define routes where we DO NOT want breadcrumbs
  const hiddenRoutes = ['/', '/adminLogin', '/signup', '/unauthorized'];
  if (hiddenRoutes.includes(path) || path.startsWith('/pdf/')) {
    return null;
  }

  // Fallback if not mapped
  if (!items) {
    return null;
  }

  return (
    <div className="configurePage" style={{ marginBottom: 0, paddingBottom: 0, width: '100%' }}>
      <Breadcrumbs items={items} />
    </div>
  );
};

export default GlobalBreadcrumbs;
